import { render, staticRenderFns } from "./blogDataDelete.vue?vue&type=template&id=980c56c6&"
import script from "./blogDataDelete.vue?vue&type=script&lang=js&"
export * from "./blogDataDelete.vue?vue&type=script&lang=js&"
import style0 from "./blogDataDelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports